import { ConfigContainerChild, ConfigFilter } from "../types";
import { FeatureDataSource } from "../../../ducks/showFeature/types";

export const checkIsLoading = (
  dataSources: FeatureDataSource[],
  config: ConfigContainerChild,
  filters: ConfigFilter[],
) =>
  config?.children?.some(child => {
    const filter = filters?.find(({ name }) => name === child.options?.filterName);

    return (
      !!filter && !!child.options?.filterName && !dataSources?.some(({ name }) => name === filter.relatedDataSource)
    );
  });
